(function ($) { // jQuery code here 

	function mapNumber(number, in_min, in_max, out_min, out_max) {
		return (number - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
	}


	$(document).ready(function (e) {

		var headerHeight = $('header').height();

		$('#MainContent').css('marginTop', headerHeight - 5 + 'px');

		setTimeout(function () {
			var headerHeight = $('header').height();
			$('#MainContent').css('marginTop', headerHeight - 5 + 'px');
		}, 500);


		$(window).resize(function () {
			var headerHeight = $('header').height();
			$('#MainContent').css('marginTop', headerHeight - 5 + 'px');
		});

		$('#hero-down').on('click', function () {
			var winheight = $(window).height();

			$('html, body').animate({
				scrollTop: winheight
			}, 500);
		});






		$('.variant-changer').on('change', function (e) {


			var productId = $(this).data("productid");

			var price = $(this).find(":selected").data("price");
			var euro = price / 100;
			price = euro.toLocaleString("de-DE", { style: "currency", currency: "EUR" });

			$('#price-' + productId).html(price);


		});








		$('.dropdown-hover').hover(function (e) {
			$('.header__active-dropdown').css('opacity', 0);
			$('.header__active-dropdown').hide();
			$('.header__active-dropdown_right').css('opacity', 0);
			$('.header__active-dropdown_right').hide();
			$('.mega-nav').hide();
			$('.subnav').css('display', 'none');

			$('.header__active-dropdown').css('opacity', 1);
			$('.header__active-dropdown').show();
			$('.mega-nav').show();
			$('#subnav_' + $(this)[0].dataset.linkid).show();

			var headerHeight = $('.site-header').height();

			$('.header__active-dropdown').css('top', headerHeight + 'px')

		}, function () {
			$('.header-table').hover(function () {




			}, function () {
				$('.header__active-dropdown').css('opacity', 0);
				$('.header__active-dropdown').hide();
				$('.mega-nav').hide();
				$('.subnav').hide();
			});


		});

		$('#search-nav').hover(function (e) {
			$('.header__active-dropdown').css('opacity', 0);
			$('.header__active-dropdown').hide();
			$('.mega-nav').hide();
			$('.subnav').hide();
			$('.header__active-dropdown_right').css('opacity', 0);
			$('.header__active-dropdown_right').hide();
			$('.mega-nav').hide();
			$('.subnav').hide();
		});

		$('.dropdown-hover-right').hover(function (e) {
			$('.header__active-dropdown_right').css('opacity', 0);
			$('.header__active-dropdown_right').hide();
			$('.mega-nav').hide();
			$('.subnav').css('display', 'none');

			$('.header__active-dropdown_right').css('opacity', 1);
			$('.header__active-dropdown_right').show();
			$('.mega-nav').show();
			$('#subnav_right_' + $(this)[0].dataset.linkid).show();

			var headerHeight = $('.site-header').height();

			$('.header__active-dropdown_right').css('top', headerHeight + 'px')

		}, function () {
			$('.header-table').hover(function () {

			}, function () {
				$('.header__active-dropdown_right').css('opacity', 0);
				$('.header__active-dropdown_right').hide();
				$('.mega-nav').hide();
				$('.subnav').hide();
			});


		});


		$(window).scroll(function () {
			if ($(this).scrollTop() > 50) {
				$('.site-header').addClass('sticky-active');
			} else {
				$('.site-header').removeClass('sticky-active');
			}

			var headerHeight = $('.site-header').height();

			$('.header__active-dropdown').css('top', headerHeight + 'px')
		});

		var lastScrollTop = 0;
		$(window).scroll(function () {
			var currentScrollTop = $(this).scrollTop();
			if (currentScrollTop > lastScrollTop) {
				$('.announcement-bar p').css('height', '0px');
				$('.announcement-bar').css('padding-top', '0px');
				$('.announcement-bar').css('padding-bottom', '0px');
			} else {
				$('.announcement-bar p').css('height', '100%');
				$('.announcement-bar').css('padding-top', '4px');
				$('.announcement-bar').css('padding-bottom', '4px');
			}
			lastScrollTop = currentScrollTop;
		});


		var header = $("body");


		$(window).scroll(function () {
			var scroll = $(window).scrollTop();
			var scrollMod = scroll % 1000;  // we are interested in each 1000px block

			if (scroll >= 300) {
				header.addClass("scrolled");
			} else {
				header.removeClass("scrolled");
			}

			var rotate;
			if (scrollMod <= 250) {
				rotate = mapNumber(scrollMod, 0, 250, 0, 3);  // from 0px to 250px, rotate from 0 to 10 deg
			} else if (scrollMod <= 500) {
				rotate = mapNumber(scrollMod, 250, 500, 3, 0);  // from 250px to 500px, rotate from 10 to 0 deg
			} else if (scrollMod <= 750) {
				rotate = mapNumber(scrollMod, 500, 750, 0, -5);  // from 500px to 750px, rotate from 0 to -10 deg
			} else {
				rotate = mapNumber(scrollMod, 750, 1000, -5, 0);  // from 750px to 1000px, rotate from -10 to 0 deg
			}


			var bobbing = 4 * Math.sin(scroll / 250);  // the ship bobs up and down every 50px of scroll

			$('.ship').attr('transform', 'translate(0,' + bobbing + ') rotate(' + rotate + ')');

		});



		$('.dropdown-faq').click(function () {

			var faqcard = $(this).find('.dropdown__btm');
			var actionrot = $(this).find('.dropdown-faq-action');

			faqcard.toggleClass('dropdown-faq-open');
			actionrot.toggleClass('action-rotated');
			$(this).toggleClass('dropdown-whole-open');
		});

		/*
		$('.btn--add-to-cart').click(function (e) {
			e.preventDefault();
		})

		$('.add-cart-item-form button').click(function (evt) {
			evt.preventDefault();
			$(this).html('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="25px" height="25px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><circle cx="50" cy="50" fill="none" stroke="#fff" stroke-width="3" r="35" stroke-dasharray="164.93361431346415 56.97787143782138"><animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform></circle>');

		});

*/
		/*
				window.SLIDECART_LOADED = function(cart) {
					// Fires once the cart has loaded
					var el = $('#slidecarthq');
					el = el.find('.header');
					el = el.find('button');
					el.html('<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M32 29.714L53.714 8 56 10.286 34.286 32 56 53.714 53.714 56 32 34.286 10.286 56 8 53.714 29.714 32 8 10.286 10.286 8 32 29.714z"></path></svg>');
				}
			
				*/





		var $sectionScroll = $("[data-scroll-to-section]");
		$sectionScroll.click(function (e) {
			e.preventDefault();
			$("html, body").animate(
				{
					scrollTop: $("#shopify-section-1550065488646").offset().top + 1
				},
				400
			);
		});


		/* Product description accordion */
		$("#productDescription h3:first-child").addClass("active");
		$("#productDescription h3").on("click", function () {
			$(this).toggleClass("active");
		});


		var options = {
			accessibility: true,
			prevNextButtons: false,
			pageDots: true,
			wrapAround: true,
			autoPlay: 4500,
			setGallerySize: false

		};

		var carousel = document.querySelector('[data-carousel]');
		var slides = document.getElementsByClassName('carousel-cell');

		if (carousel != undefined && slides != undefined) {
			var flkty = new Flickity(carousel, options);

			flkty.on('scroll', function () {
				flkty.slides.forEach(function (slide, i) {
					var image = slides[i];
					var x = (slide.target + flkty.x) * -1 / 3;
					image.style.backgroundPosition = x + 'px';
				});
			});


		}

	});



	$(document).ready(function () {

		$('.filter-fixed').on('click', function () {
			$('div.snize div.snize-filters-sidebar').toggle();
			$('.bg-filter-bar').fadeIn();
			$('.filter-close').fadeIn();

		})


		/*
			function openCart(){
				window.SLIDECART_OPEN();
			}
		
			$(document).on('Searchanise.AddToCartSuccess', function(event, add_to_cart_id, product) {
				window.SLIDECART_UPDATE(window.SLIDECART_OPEN(openCart));
			});
		*/




		$('.burger').on('click', function () {
			$('.mobile-navigation').toggleClass('opennav');
			$('.burger').toggleClass('openburger');
			$('.mobile-nav-ship').toggleClass('nav-ship-show');
		});

		$('.mobile-nav__toplink').on('click', function () {
			var childlist = $(this).next();
			childlist.toggleClass('openchild');

			var arrow = $(this).find('.arrow-toggle');
			arrow.toggleClass('openarrow');
		})

		$('.mobile-nav__childlink').on('click', function () {
			var grandlist = $(this).next();
			grandlist.toggleClass('openchild');
			console.log(grandlist);

			var arrow = $(this).find('.arrow-toggle');
			arrow.toggleClass('openarrow');
		})

		$('#search-nav').on('click', function (e) {
			e.preventDefault();
			console.log('search clicked');
			$('#search-popup').toggle();
			$("#search-popup input").focus();
		});

	});





})(jQuery);



